import { Component, Inject } from '@angular/core';
import {
  DwComponent,
  DwComponentType,
  DwMenuService,
  DwMetaDataListCardConfigData,
  DwMetaDataService,
  DwMetaDataServiceToken,
  DwRoutingService
} from '@devwareapps/devware-cap';
import { take } from 'rxjs/operators';
import { AppMetaDataItemNames } from '../../../../../meta-data/app-meta-data.service';
import { StudentCourseProgressStatusService } from '../../../services/student-course-progress-status.service';
import { DateTimeUtilService } from '../../../../shared/util/date-time-util.service';
import { CourseProgressStatusChip } from '../course-progress-status.util';
import { CourseStudentProgressCardComponent } from '../course-student-progress-card/course-student-progress-card.component';

@DwComponent<DwMetaDataListCardConfigData>({
  name: 'Course Card - Student Progress Simple',
  key: 'courseCard-StudentProgressSimple',
  componentType: DwComponentType.card,
  isGlobal: false,
  parentItemName: AppMetaDataItemNames.Student,
  configData: {
    contentItemDefinitions: [{
      display: 'Main',
      contentItemKey: 'main'
    }]
  }
})
@Component({
  selector: 'app-course-student-progress-simple-card',
  templateUrl: './course-student-progress-simple-card.component.html',
  styleUrls: ['./course-student-progress-simple-card.component.scss']
})
export class CourseStudentProgressSimpleCardComponent extends CourseStudentProgressCardComponent {

  progressLabel: string;
  statusChips: CourseProgressStatusChip[] = [];

  constructor(
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    dwRoutingService: DwRoutingService,
    dateTimeUtilService: DateTimeUtilService,
    dwMenuService: DwMenuService,
    private readonly progressStatusService: StudentCourseProgressStatusService
  ) {
    super(dwMetaDataService, dwRoutingService, dateTimeUtilService, dwMenuService);
  }

  setupCard(): void {
    super.setupCard();

    if (!this.data) {
      return;
    }

    this.progressPercent = this.data.StudentCourseIsEndorsed
      ? 100
      : Math.max(0, Math.min(100, Math.round(this.data.StudentCoursePercentComplete || 0)));
    this.progressLabel = `${this.progressPercent}% complete`;
    this.loadStatusChip(this.data.StudentCourseStudentCourseProgressStatusId);
  }

  private loadStatusChip(statusId?: number): void {
    this.statusChips = [];

    if (!statusId) {
      return;
    }

    this.progressStatusService.getStatusChip(statusId)
      .pipe(take(1))
      .subscribe(chip => {
        if (this.data?.StudentCourseStudentCourseProgressStatusId === statusId) {
          this.statusChips = chip ? [chip] : [];
        }
      });
  }

}
